export default "__VITE_ASSET__6851fc47__"